import { RegisterOptions } from 'react-hook-form';
import { type TFunction } from 'i18next';

import { FIELD_MULTI_EMAIL } from '../constants';
import { Field } from '../dynamic-input-fields.type';
import {
  getBankValidation,
  getBasicValidationRules,
  getDateValidation,
  getEmailValidation,
  getInstagramValidation,
  getMultiEmailValidation,
  getPhoneValidation,
  getTextValidation,
  getURLValidation,
} from '../validations';

export const generateRegisterOptions = (field: Field, t: TFunction, optionalFields?: boolean): RegisterOptions => {
  const baseOptions = getBasicValidationRules(field, t, optionalFields);

  switch (field.dataType) {
    case 'email':
      return { ...baseOptions, ...getEmailValidation(t) } as RegisterOptions;
    case FIELD_MULTI_EMAIL:
      return { ...baseOptions, ...getMultiEmailValidation(field, t) } as RegisterOptions;
    case 'text':
      return { ...baseOptions, ...getTextValidation(t) } as RegisterOptions;
    case 'numeric':
      return { ...baseOptions, ...getPhoneValidation(t) } as RegisterOptions;
    case 'date':
      return { ...baseOptions, ...getDateValidation(t) } as RegisterOptions;
    case 'iban':
    case 'vat':
      return { ...baseOptions, ...getBankValidation(field.dataType, t) } as RegisterOptions;
    case 'url':
      return { ...baseOptions, ...getURLValidation(t) } as RegisterOptions;
    case 'instagram':
      return { ...baseOptions, ...getInstagramValidation(t) } as RegisterOptions;
    default:
      return baseOptions;
  }
};
